export const actions = {
    SET_JWT: 'SET_JWT',
    REMOVE_JWT: 'REMOVE_JWT',
    SET_CLIENT_ID: 'SET_CLIENT_ID',
    SET_PHONE_NUMBER: 'SET_PHONE_NUMBER',
    PATCH_PHONE_NUMBER: 'PATCH_PHONE_NUMBER',
    SET_IS_APP: 'SET_IS_APP',
    SET_APP_DETAILS: 'SET_APP_DETAILS',
    SET_CATERING_MODE: 'SET_CATERING_MODE',
}

export const setJWT = tokens => ({
    type: actions.SET_JWT,
    payload: tokens,
})

export const removeJWT = () => ({
    type: actions.REMOVE_JWT,
})

export const setClientID = clientID => ({
    type: actions.SET_CLIENT_ID,
    payload: clientID,
})

export const setPhoneNumber = phone => ({
    type: actions.SET_PHONE_NUMBER,
    payload: phone,
})

export const patchPhoneNumber = phone => ({
    type: actions.PATCH_PHONE_NUMBER,
    payload: phone,
})

export const setIsApp = isApp => ({
    type: actions.SET_IS_APP,
    payload: isApp,
})

export const setAppDetails = payload => ({
    type: actions.SET_APP_DETAILS,
    payload,
})

export const setCateringMode = isCateringMode => ({
    type: actions.SET_CATERING_MODE,
    payload: isCateringMode,
})
